export const LOCAL_STORAGE_KEYS = {
  WISHLIST_GUEST_SHARE_KEY: 'WISHLIST_GUEST_SHARE_KEY',
  WISHLIST_USER_ID: 'WISHLIST_USER_ID',
  LOGIN_PHONE: 'ss_login_phone',
  LOGIN_PHONE_COUNTRY: 'ss_login_phone_country',
  LOGIN_REMEMBER_ME: 'ss_login_remember_me',
  APP_PROMO_DISMISSED: 'ss_app_promo_dismissed',
};
